(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pd-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // FOI-372: make this the single scroll controller. When the announcement bar is in
      // "on scroll up" mode (renders .utility-bar--scroll-up), drive its reveal from here
      // too, so header + announcement + secondary header pin/unpin together off ONE handler
      // instead of racing two independent listeners (which desynced and left gaps/overlaps).
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.syncAnnouncement = !!document.querySelector('.announcement-bar-section .utility-bar--scroll-up');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Clamp so overscroll bounce can't read as a direction change
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const delta = scrollTop - this.currentScrollTop;
      this.currentScrollTop = scrollTop;
      if (delta === 0) return;

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.appliedDirection = null;
        requestAnimationFrame(this.reset.bind(this));
        return;
      }

      if (scrollTop <= this.headerBounds.bottom) return;

      this.header.classList.add('scrolled-past-header');

      // FOI-372: real touch devices fire tiny opposite-direction deltas
      // (finger lift-off, the URL bar collapsing/expanding) that DevTools
      // emulation never produces. Flipping on every 1px reversal restarted
      // the three bars' slide transitions mid-flight — the "wonky moments"
      // QC saw only on device. Require real travel before changing state,
      // and never re-apply the state a direction has already applied.
      const direction = delta > 0 ? 'down' : 'up';
      if (direction !== this.pendingDirection) {
        this.pendingDirection = direction;
        this.pendingTravel = 0;
      }
      this.pendingTravel += Math.abs(delta);

      if (direction === this.appliedDirection) return;
      if (this.pendingTravel < 10) return;

      if (direction === 'down') {
        if (this.preventHide) return;
        this.appliedDirection = 'down';
        requestAnimationFrame(this.hide.bind(this));
      } else if (!this.preventReveal) {
        this.appliedDirection = 'up';
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        // keep hiding while reveal is suppressed; leave appliedDirection on
        // 'down' so the reveal re-attempts once the suppression expires
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.setAnnouncementState('hide');
      this.closeMenuDisclosure();
      // The closeSearchModal function isn’t working as expected - it’s triggered randomly,
      // causing this bug: https://prosperdigital.atlassian.net/browse/FOI-226
      // Also, it doesn’t make much sense to call it here - once the search modal is open,
      // page scrolling is already disabled, so there’s no need to hide it on scroll.
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setAnnouncementState('reveal');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setAnnouncementState('reset');
    }

    // FOI-372: drive the announcement bar's slide in lockstep with the header so all three
    // bars ease together on scroll-up. Mirrors the header's own class model:
    //   reveal → show + animate (slides down from the hidden position to top:0)
    //   hide   → hidden (slides up to -announcement-height); animate persists from a prior reveal
    //   reset  → clear all (bar returns to normal flow near the top of the page)
    // Only touches the bar in "on scroll up" mode (syncAnnouncement).
    setAnnouncementState(state) {
      if (!this.syncAnnouncement || !this.announcementBar) return;
      const cl = this.announcementBar.classList;
      if (state === 'reveal') {
        cl.add('announcement-bar-section-show', 'animate');
        cl.remove('announcement-bar-section-hidden');
      } else if (state === 'hide') {
        cl.add('announcement-bar-section-hidden');
        cl.remove('announcement-bar-section-show');
      } else {
        cl.remove('announcement-bar-section-show', 'announcement-bar-section-hidden', 'animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
